<div class="page-content row center">
	<div class="col l7 m12">
		<!-- Descripción en forma de título-->
		<h4>{{title}}</h4>
		<!-- Descripción complementaria menos resaltada -->
		<p class="fnt-22" color="info">{{information}}</p>
		<div class="row margin-bottom-0">
			<br>
			<ng-container *ngIf="(user?.userType || 0) == '4'">
				<div class="col l6 m6 s12" *ngIf="error" (click)="openTapTarget()">
					<a class="btn waves-effect mouse-action-theme-waves center-all" tag-style="outline-theme"
						mouse-action="tag-style-theme-hover" apply="theme" white="true">
						<i class="material-icons left">privacy_tip</i> Más información
					</a>
				</div>
				<!-- Boton princial (Mapa Estratégico) -->
				<div class="col l6 m6 s12 margin-bottom-5" *ngFor="let item of homePermits">
					<a tabindex="0" [routerLink]="['/'+item.link]"
						class="btn waves-effect mouse-action-theme-waves center-all mouse-action-tag-style-theme-focus"
						tag-style="outline-theme" mouse-action="tag-style-theme-hover" apply="theme" white="true">
						<i class="material-icons left">{{item.icon}}</i> {{item.alias || item.name}}
					</a>
				</div>
				<ng-container *ngIf="user?.userPermits | getBooleanResult:[1, 2, 3, 4]:'includeAll':'num'">
					<div class="col l6 m6 s12 margin-bottom-5" *ngIf="!error">
						<a tabindex="0" (click)="getEntities()" white="true"
							class="btn waves-effect mouse-action-theme-waves center-all modal-trigger mouse-action-tag-style-theme-focus"
							href="#modal-index" tag-style="outline-theme" mouse-action="tag-style-theme-hover" apply="theme">
							<i class="material-icons left">domain</i> Ver Entidades
						</a>
					</div>
				</ng-container>
			</ng-container>
		</div>
		<ng-container *ngIf="(user?.userType || 0) == '4'">
			<div class="row mtn">
				<!-- Botón submenu reportes -->
				<div class="col l6 m6 s12 margin-bottom-5">
					<a tabindex="0" white="true" apply="theme" data-target="downReports"
						class="btn waves-effect mouse-action-theme-waves center-all dropdown-index mouse-action-tag-style-theme-focus"
						*ngIf="reportPermits?.length > 0" tag-style="outline-theme" mouse-action="tag-style-theme-hover">
						<i class="material-icons left">wysiwyg</i>
						Reportes
						<i class="material-icons right">arrow_drop_down</i>
					</a>
				</div>
				<!-- Botón submenu indicadores -->
				<div class="col l6 m6 s12 margin-bottom-5">
					<a tabindex="0" white="true" apply="theme" data-target="downIndicators"
						class="btn waves-effect mouse-action-theme-waves center-all dropdown-index mouse-action-tag-style-theme-focus"
						*ngIf="markerPermits?.length > 0" tag-style="outline-theme" mouse-action="tag-style-theme-hover">
						<i class="material-icons left">score</i>
						Indicadores
						<i class="material-icons right">arrow_drop_down</i>
					</a>
				</div>
			</div>
		</ng-container>
		<ng-container *ngIf="(user?.userType || 0) == '4'">
			<!-- submenu marcadores -->
			<ul color="background" apply="theme" id="downIndicators" class="dropdown-content ul-theme"
				*ngIf="markerPermits?.length > 0">
				<ng-container *ngFor="let item of markerPermits; last as li">
					<li [ngStyle]="{ 'border-bottom': li ? 'none' : '1px solid #e0e0e0' }">
						<a class="waves-effect" apply="theme" mouse-action="theme-waves" [routerLink]="['/'+item.link]">
							{{item.alias || item.name}}
						</a>
					</li>
				</ng-container>
			</ul>
			<!-- submenu reportes -->
			<ul color="background" apply="theme" id="downReports" class="dropdown-content ul-theme"
				*ngIf="reportPermits?.length > 0">
				<ng-container *ngFor="let item of reportPermits; last as li">
					<li [ngStyle]="{ 'border-bottom': li ? 'none' : '1px solid #e0e0e0' }">
						<a class="waves-effect" apply="theme" mouse-action="theme-waves" [routerLink]="['/'+item.link]">
							{{item.alias || item.name}}
						</a>
					</li>
				</ng-container>
			</ul>
		</ng-container>
	</div>
	<!-- Imagen adjunta a la página -->
	<div class="dashboard-image hide-on-med-and-down">
		<img src="assets/img/monitor.png" style="width:100%;height:100%;">
	</div>
</div>
<!-- Botón para mostrar información de los errores -->
<div class="fixed-action-btn open-tap-trarget" *ngIf="error">
	<a (click)="openTapTarget()" apply="theme" id="menus" background="theme"
		class="waves-effect waves-light btn btn-floating">
		<i class="material-icons" apply="theme" color="theme">error_outline</i>
	</a>
	<div class="tap-target" data-target="menus" apply="theme" background="theme">
		<div class="tap-target-content">
			<h5 apply="theme" color="theme">Estado: {{status === 'undefined' ? '0' : status }}</h5>
			<h6 apply="theme" color="theme">{{error}}</h6>
		</div>
	</div>
</div>
<!-- Modal Structure -->
<ng-container *ngIf="user?.userPermits | getBooleanResult:[1, 2, 3, 4]:'includeAll':'num'">
	<div id="modal-index" class="modal modal-index">
		<div class="modal-content" apply="theme" background="section" color="body">
			<div class="row">
				<div class="col s12 left">
					<h6 class="title margin-top-0 margin-bottom-10 padding-bottom-10">Filtrar Información Por Entidades
					</h6>
				</div>
				<div class="col s12">
					<app-select2 [type]="'single'" [keys]="['ent_razon_social', 'nit']" [element]="user?.entitiesList || []"
						(sendValues)="setEntity($event)">
					</app-select2>
				</div>
			</div>
		</div>
		<div class="modal-footer border-top" apply="theme" background="section" color="body">
			<button [tabindex]="selectedEntity ? 0 : -1" (click)="showEntity()" [ngClass]="{ disabled: !selectedEntity }"
				class="modal-close waves-effect mouse-action-theme-waves btn-flat mouse-action-tag-style-theme-focus"
				apply="theme" tag-style="outline-theme" mouse-action="tag-style-theme-hover">
				<i class="material-icons left">search</i>
				Filtrar
			</button>
		</div>
	</div>
</ng-container>